import { VStack } from '@bpba/ui-components';
import { FormularioDataExistente } from './FormularioDataExistente';
import { DataOrigin, InputSelectData } from './useDataInputSelect';
import { ButtonNewData } from './ButtonNewData';
import { FC } from 'react';
import { UseFormRegister, FieldErrors, FieldValues } from 'react-hook-form';
import { FormTitle } from './FormTitle';

export type InputContainerProps<T extends FieldValues> = {
  register: UseFormRegister<T>;
  errors: FieldErrors<T>;
};

type Props<T extends FieldValues> = {
  title: string;
  titleNewButton: string;
  placeholderTitle: string;
  dataOptionsList: T[] | undefined;
  formData: InputSelectData<T>;
  getLabel: (data: T) => string;
  inputDataChildren: FC<InputContainerProps<T>>;
  name: string;
  customRef?: (ref: HTMLParagraphElement | null) => void;
};

export const InputSelectContainer = <T extends FieldValues>(props: Props<T>) => {
  const { title, titleNewButton, placeholderTitle, dataOptionsList, formData, getLabel, inputDataChildren, name, customRef } = { ...props };
  const { dataOrigin, setDataOrigin, selectRegister, selectErrors, inputRegister, inputErrors } = formData;

  const showButtonNew = dataOptionsList && dataOptionsList.length > 0;
  const showInput = dataOrigin === DataOrigin.INPUT_DATA;

  return (
    <>
      <FormTitle ref={customRef} margin={showInput ? '0 0 16px' : '0'} marginTop={0}>
        {title}
      </FormTitle>

      <VStack justifyContent={'end'} minWidth={[null, 350]}>
        {/** Ingreso de datos mediante <select> */}
        {!showInput && (
          <FormularioDataExistente
            dataOptionsList={dataOptionsList ?? []}
            disable={dataOrigin !== DataOrigin.SELECT_DATA}
            getLabel={getLabel}
            placeholderTitle={placeholderTitle}
            name={name}
            register={selectRegister}
            errors={selectErrors}
          />
        )}
      </VStack>

      {showButtonNew && <ButtonNewData title={titleNewButton} dataOrigin={dataOrigin} setDataOrigin={setDataOrigin} />}

      {/** Ingreso de datos mediante <input> */}
      <VStack marginTop={0} paddingX={0} display={showInput ? 'flex' : 'none'} aria-hidden={!showInput}>
        {inputDataChildren({
          register: inputRegister,
          errors: inputErrors,
        })}
      </VStack>
    </>
  );
};
